<template>
  <v-container id="search" fluid tag="section">
    <v-row>
      <router-view :key="$route.path" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {};
  },
};
</script>
